// @ts-nocheck
/* eslint-disable */
export const mapPointIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#223267" fill-rule="evenodd" d="M8 1.333C5.054 1.333 2.667 4.001 2.667 7c0 2.974 1.702 6.208 4.358 7.45a2.3 2.3 0 0 0 1.95 0c2.656-1.242 4.358-4.476 4.358-7.45 0-3-2.388-5.667-5.333-5.667M8 8a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 8" clip-rule="evenodd"/></svg>`,
    name: 'map-point' as const
};